/* =========================================================
   UWP Set Content（SHOP-14）
   - 「セット内容」で単品（ネックレスのみ）を選んだら、SCPOの「耳飾り」を隠す
   - SCPOの条件分岐はShopifyのバリアントをきっかけにできないため、テーマ側で代行する
   - 隠すときはSCPO自身の hide() を呼ぶ。こうするとSCPOは
     ①必須チェックから外す ②カートに送る値から外す ③追加料金の合計から外す
     （2026-10-06 本番ページで実測）。CSSで見えなくするだけだと①〜③が残るので使わない
   ========================================================= */
(() => {
  // 単品のバリアント名に含まれる言葉 → 隠すSCPOの選択肢（public_name）
  const SINGLE_WORD = '単品';
  const HIDE_ON_SINGLE = ['耳飾り'];

  function scpoOptions() {
    const products = window.BOLD?.options?.app?.optionProducts;
    if (!products?.length) return [];
    return products.flatMap(p => (p.optionSets || []).flatMap(s => s.options || []));
  }

  function currentVariantTitle() {
    const json = document.querySelector('variant-picker script[type="application/json"]');
    if (!json) return '';
    try {
      return JSON.parse(json.textContent)?.title || '';
    } catch (e) {
      return '';
    }
  }

  function apply(variantTitle) {
    const single = (variantTitle || '').includes(SINGLE_WORD);
    scpoOptions()
      .filter(o => HIDE_ON_SINGLE.includes(o.publicName))
      .forEach(o => {
        if (single && o.isVisible()) o.hide();
        if (!single && !o.isVisible()) o.show();
      });
  }

  function init() {
    // 単品のバリアントが無い商品では何もしない
    const picker = document.querySelector('variant-picker');
    if (!picker || !picker.textContent.includes(SINGLE_WORD)) return;

    document.addEventListener('variant:update', e => {
      apply(e.detail?.resource?.title);
    });

    // SCPOは読み込みが遅れて組み上がるので、出そろうまで待ってから初回を当てる
    let tries = 0;
    const timer = setInterval(() => {
      tries += 1;
      if (scpoOptions().length || tries > 50) {
        clearInterval(timer);
        apply(currentVariantTitle());
      }
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
